import React, { useCallback } from 'react';
import ModalManager, { useModal } from '@ebay/nice-modal-react';
import Modal from 'UI/Modal';
import NewTransactionButton from 'components/buttons/NewTransactionButton';
import NewClientButton from 'components/buttons/NewClientButton';
import styles from './styles.module.scss';


const SampleTransactionModal = ModalManager.create(() => {
  const modal = useModal();

  const handleModalClose = useCallback(() => {
    modal.hide();
  }, [modal]);

  return (
    <Modal
      title={
        <>
          This action will be available on real data.
          <br />
          <br />
          Start by creating your first transaction or adding your first client.
        </>
      }
      isOpen={modal.visible}
      onClose={handleModalClose}
    >
      <p className={styles.label} />

      <div className={styles.buttonContainer}>
        <NewTransactionButton onClickCallback={handleModalClose} />
        <NewClientButton onClick={handleModalClose} />
      </div>
    </Modal>
  );
});

export default React.memo(SampleTransactionModal);
